import DefaultImage from '../assets/projects/images/Default.jpg';
import HelloWorld from '../assets/articles/images/HelloWorld.png';
import RealLreal from '../assets/articles/images/REAL-LREAL.png';
import AxisControl from '../assets/articles/images/Axis-Control.png';
import StateMachine from '../assets/articles/images/StateMachine.png';
import FBInheritance from '../assets/articles/images/FB-Inheritance.png';

export default {
    articles: [
        {
            id: 0,
            title: 'How to split a STRING in TwinCAT/Codesys',
            image: HelloWorld,
            url: "https://raw.githubusercontent.com/hganchev/hganchev-portfolio/refs/heads/main/Articles/TwinCAT/how-to-split-a-STRING-in-TwinCAT/README.md",
            date: "August 27, 2023",
            label: "TwinCAT",
            description: "This article explains how to split a STRING in TwinCAT/Codesys using the built-in functions and provides examples for practical applications."
        },
        {
            id: 1,
            title: 'How to round a REAL in TwinCAT/Codesys',
            image: RealLreal,
            url: "https://raw.githubusercontent.com/hganchev/hganchev-portfolio/refs/heads/main/Articles/TwinCAT/how-to-round-a-REAL-in-TwinCAT/README.md",
            date: "August 29, 2023",
            label: "TwinCAT",
            description: "This article provides a comprehensive guide on how to round a REAL value in TwinCAT/Codesys, including examples and best practices."
        },
        {
            id: 2,
            title: 'How to control axis/motor in TwinCAT/Codesys',
            image: AxisControl,
            url: "https://raw.githubusercontent.com/hganchev/hganchev-portfolio/refs/heads/main/Articles/TwinCAT/how-to-control-axis-in-TwinCAT/README.md",
            date: "March 9, 2024",
            label: "TwinCAT",
            description: "This article covers the basics of controlling an axis or motor in TwinCAT/Codesys, including setup, configuration, and programming examples."
        },
        {
            id: 3,
            title: 'How to Implement State Machine Programming in TwinCAT/Codesys',
            image: StateMachine,
            url: "https://raw.githubusercontent.com/hganchev/hganchev-portfolio/refs/heads/main/Articles/TwinCAT/how-to-state-machine-in-TwinCAT/README.md",
            date: "June 21, 2025",
            label: "TwinCAT",
            description: "This article explains how to implement state machine programming in TwinCAT/Codesys, providing a structured approach to managing complex control logic."
        },
        {
            id: 4,
            title: 'How to Use Function Block Inheritance (EXTENDS) in TwinCAT/Codesys',
            image: FBInheritance,
            url: "https://raw.githubusercontent.com/hganchev/hganchev-portfolio/refs/heads/main/Articles/TwinCAT/how-to-use-fb-extends-in-TwinCAT/README.md",
            date: "July 29, 2026",
            label: "TwinCAT",
            description: "This article explains how to use function block inheritance (EXTENDS) in TwinCAT/Codesys, providing examples and best practices."
        },
    ],
}